import React, { FunctionComponent, useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import { PopupDismissalKeys } from "../../../../../store/onboarding/types";
import { useDispatch } from "react-redux";
import { showConfirmDialog } from "../../../../../store/confirm-dialog/actions";
import { toastr } from "react-redux-toastr";
import { resetDismissedModal } from "../../../../../store/superuser/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

type OwnProps = {};

type Props = OwnProps;

const ManageDismissedModals: FunctionComponent<Props> = () => {
  const [displayLoaderModalKey, setDisplayLoaderModalKey] = useState<string>('');
  const dispatch = useDispatch();
  const modalData = [
    {title: "Upload Data Guide", description: "Instructions for uploading data.", modalKey: PopupDismissalKeys.UPLOAD_DATA_GUIDE, 
      modalPath: 'My Data > Reading or Behavior Data > Upload Data Guide' },
    {title: "Teacher Invite Send", description: "Modal for sending teacher invites.", modalKey: PopupDismissalKeys.TEACHER_INVITE_SEND, 
      modalPath: 'District Admin Account > My Staff > Invite Individually > Teacher Invite Send' },
    {title: "Invite New User", description: "Modal for creating a new user during invite.", modalKey: PopupDismissalKeys.TEACHER_INVITE_CREATE_USER, 
      modalPath: 'District Admin Account > My Staff > Invite Individually > Invite New User' },
    {title: "Grade Level Change for SSRS", description: "Modal for changing grade levels in SSRS.", modalKey: PopupDismissalKeys.GRADE_LEVEL_CHANGE_FOR_SSRS, 
      modalPath: 'My Data > Selected Data Period > SSRS Assessment > Grade Level Change for SSRS' },
    {title: "Upload Student Demographics", description: "Modal for uploading student demographics.", modalKey: PopupDismissalKeys.UPLOAD_STUDENT_DEMOGRAPHICS, 
      modalPath: 'Educators & Student Data > Student Tab > Upload Student Demographics' },
    // {title: "Upload Teacher Roster", description: "Modal for uploading teacher roster.", modalKey: PopupDismissalKeys.UPLOAD_TEACHER_ROSTER, 
    //   modalPath: 'My Data > Reading or Behavior Data > Upload Teacher Roster' },
    {title: "Set Goal", description: "Modal for setting goals.", modalKey: PopupDismissalKeys.SET_GOAL, 
      modalPath: 'Reading or Behavior Caseload > Recommendations > Create New Group > Set Goal' },
    {title: "Set Goal from Group Card", description: "Modal for setting goals from group card.", modalKey: PopupDismissalKeys.SET_GOAL_FROM_GROUP_CARD, 
      modalPath: 'My Data > Create Manual Group >  Set Goal' },
    {title: "Drop Last Student Group Card", description: "Modal for dropping last student group card.", modalKey: PopupDismissalKeys.DROP_LAST_STUDENT_GROUP_CARD, 
      modalPath: 'Reading or Behavior Caseload > Green Group (Unfinished Group) > Move Student to Another Group > Drop Last Student Group Card' },
    {title: "Drop Last Student Intervention Group Card", description: "Modal for dropping last student intervention group card.", modalKey: PopupDismissalKeys.DROP_LAST_STUDENT_INTERVENTION_GROUP_CARD, 
      modalPath: 'Reading or Behavior Caseload > Blue Group (Finished Group) > Move Student to Another Group > Drop Last Student Intervention Group Card' },
    {title: "Discontinue Intervention", description: "Modal for discontinuing intervention for exit student.", modalKey: PopupDismissalKeys.DISCONTINUE_INTERVENTION, 
      modalPath: 'Group Card > Exit Student > Discontinue Intervention' },
    {title: "Delete Data Period", description: "Modal for deleting data period.", modalKey: PopupDismissalKeys.DELETE_DATA_PERIOD, 
      modalPath: 'My Data > Manage Data Period > Delete Data Period' },
    {title: "Change Interventionist", description: "Modal for changing interventionist in manage workspace tab.", modalKey: PopupDismissalKeys.TEACHER_CHANGE_IN_GROUP, 
      modalPath: 'Group Card > Change Interventionist from Dropdown' },
  ]
  const handleResetDismissedModal = (modal: any) => {
      dispatch(
        showConfirmDialog({
          onConfirm: () => {
            setDisplayLoaderModalKey(modal.modalKey);
            return resetDismissedModal(modal.modalKey).then(
              (res) => {
                res.data.deleted_count 
                ?
                  toastr.success(
                    "Success",
                    `The ${modal.title} modal has been reset for ${res.data.deleted_count} user(s).`
                  ) 
                : '';
                setDisplayLoaderModalKey('');
              },
              (err: string) => {
                setDisplayLoaderModalKey('');
                toastr.error("Failed to reset the dismissed modal", err)
              }
            )
  
          },
          centered: true,
          title: "Confirm Reset ",
          text: (
            <>
              <p className="text-center">You are about to reset the <strong>{modal.title}</strong> modal for all users.</p>
              <p className="text-center">This will make the modal appear again for everyone.</p>
              <p className="text-center">
                <FontAwesomeIcon 
                  icon={faExclamationTriangle}
                  style={{ color: 'red' }}
                /> {" "}
                <i>This action cannot be undone.</i>
              </p>
            </>
          ),
          confirmButtonText: "Confirm Reset",
        })
      );
    };
  return (
    <div className="manageDistrictContainer">
      <h2 className="font-weight-bold mb-3">Manage Dismissed Modals</h2>
      <p>Reset the 'Do not show me this again' selection for all users for a specific modal 
        when its content has changed. This will make the modal appear again for everyone.</p>
      <div className="row px-3">
        <Table className="mt-4" bordered>
          <thead className="purpleTableHeader">
            <tr>
              <th>Modal Title</th>
              <th>Modal Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {modalData.map((modal) => (
              <tr key={modal.modalKey}>
                <td>{modal.title}</td>
                <td>{modal.description}<br/>{modal.modalPath}</td>
                <td>{
                  (displayLoaderModalKey == modal.modalKey) ? 
                  <span className="ml-1"><Spinner animation="border" size="sm" /></span>
                  :
                  <button className="blueBtnSm" title="Reset this modal"  onClick={(e: any) => {
                      e.stopPropagation();
                      handleResetDismissedModal(modal);
                    }}>Reset</button> 
                }
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ManageDismissedModals;